<template>
  <div id="app">
    <div class="layout">
        <Layout>
            <Header :style="{background:'#515A6E',color:'#fff'}">
                <Menu mode="horizontal" theme="dark" active-name="1">
                    <div class="layout-logo">LinkConfig</div>
                    <div class="layout-nav">
                        <MenuItem name="1">
                           <a href="https://www.mqllin.cn"  target="_blank"> <Icon type="ios-navigate"></Icon>
                            雨林笔记</a>
                        </MenuItem>
                        <MenuItem name="2">
                        <a href="http://knowledge.mqllin.cn"  target="_blank">  <Icon type="ios-keypad"></Icon>
                            Neal知识库</a>
                          
                        </MenuItem>
                    </div>
                </Menu>
            </Header>
            <Content class="layout-content" id="layout-content">
               <router-view/>
            </Content>
            <Footer class="layout-footer-center">2019-2020 &copy; LinkConfig</Footer>
        </Layout>
    </div>

  </div>
</template>
<script>
export default {
  methods:{
      
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.layout-logo{
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 20px;
    line-height: 30px;
    text-align: center;
    font-weight: blod;
    color: #fff;
    cursor: grab;
}
.layout-nav{
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
    display: flex;
    justify-content: space-around;
    line-height: 60px;
    height: 60px;
}
.layout-nav a{
    color: #eee;
}
.layout-nav a:hover{
    color: #fff;
}
.layout-content{
  min-height: 860px;
  padding: 0 50px;
   
}
.layout-footer-center{
    text-align: center;
}
 @media screen and (max-width: 1200px){
     .ivu-layout-header{
         padding: 0 20px!important;
     }
     .layout-content{
        padding: 0 20px;

     }
     .layout-logo{
        left: 0;
     }
     .layout-nav{
         width: auto;
         margin-right: 0px;
     }
    }
</style>
